import { Link } from '@mui/material';
import styled from 'styled-components';

export const Container = styled.div`
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.palette.grey[300]};
  background: ${({ theme }) => theme.palette.common.white};
  margin-bottom: 10px;
`;

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 16px 20px 16px 20px;
`;

export const Header = styled.h1`
  color: ${({ theme }) => theme.palette.text.primary};
  font-feature-settings:
    'clig' off,
    'liga' off;
  font-family: Roboto;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%; /* 27px */
  letter-spacing: 0.15px;
  margin: 0;
  padding: 0;
`;

export const DeviceRecordContainer = styled.div<{ $editing: boolean }>`
  padding: 6px 20px 20px;
  background-color: ${({ theme }) => theme.palette.common.white};
  padding-top: ${(props) => props.$editing && '0'};
  border-radius: 4px;
`;

export const DeviceRecordRow = styled.div`
  display: flex;
  flex-direction: column;
`;

export const RecordRow = styled.div`
  display: flex;
  align-items: flex-start;
  min-height: 24px;
`;

export const RowValue = styled.p`
  color: ${({ theme }) => theme.palette.text.primary};
  font-size: 16px;
  font-weight: 400;
  line-height: 150%;
  letter-spacing: 0.15px;
  margin: 0;
`;

export const FirstColumn = styled.div`
  flex: 1;
  padding: 10px 0;
  color: ${({ theme }) => theme.palette.text.primary};
  font-size: 14px;
  font-weight: 600;
  line-height: 143%;
  letter-spacing: 0.17px;
`;

export const SecondColumn = styled.div`
  flex: 3;
  padding: 10px 0;
`;

export const DevicePicture = styled.img`
  width: 24px;
  height: 24px;
`;

export const StyledName = styled.p`
  color: ${({ theme }) => theme.palette.text.primary};
  font-size: 16px;
  font-weight: 400;
  line-height: 150%;
  letter-spacing: 0.15px;
  margin: 0;
`;

export const StyledId = styled.p`
  color: ${({ theme }) => theme.palette.text.secondary};
  /* Typography/Body 1 */
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  letter-spacing: 0.15px;
  margin: 0;
  margin-left: 4px;
`;

export const MapButtonLink = styled(Link)`
  color: ${({ theme }) => theme.palette.primary.main};
  font-feature-settings:
    'clig' off,
    'liga' off;
  font-family: Roboto;
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: 26px;
  letter-spacing: 0.46px;
  cursor: pointer;
  text-decoration: none;
  margin-top: 10px;
  margin-bottom: 10px;
`;
